/** Names of the possible directions. */
export var directionNames = {
    x: ['Right', 'Left'],
    y: ['Down', 'Up']
};
/** States for the gesture. */
export var state = {
    inactive: 0,
    watching: 1,
    dragging: 2
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/mmenu-js/dist/_modules/dragevents/_settings.js
// module id = 494
// module chunks = 0